import { Button, TextField, MenuItem, List, ListItem, ListItemText, Card, CardContent, CardActions, IconButton, Typography, ListItemSecondaryAction, Tooltip } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import { useEffect, useState } from "react";
import { Edit2, Save, Send, Trash, X, XCircle } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { RootState } from "../../../../app/store";
import { setNoteShape, setNoteShapeModal } from "../../../dashboard/dashboard.reducer";
import { completeMarker, createComment, deleteTempNoteMarker, editNoteMarker, getNoteChat, getNoteDeleteRequests, getNoteListByJobNumberId, getNoteListDeleted, postNoteMarker, rejectRequestDeleteNoteMarker, requestDeleteNoteMarker } from "../../sideTab.api";
import { clearChatList, setNoteList, setNoteListDeleted } from "../../sideTab.reducer";

export default function NoteShapeModal() {

  const dispatch = useDispatch()

  const { noteShapeModal, noteShape } = useSelector((state: RootState) => state.dashboard)
  const { chatList, requestDeleteList, jobNumberIdActive, noteList, noteListDeleted, noteEnums } = useSelector((state: RootState) => state.sideTab)

  const [form, setForm] = useState<any>({
    markerImportType: 0,
    markerType: 2,
    name: "",
    description: "",
    style: "",
    latitude: "",
    longitude: "",
    lineData: JSON.stringify(noteShape),
    jobNumberId: jobNumberIdActive.id,
    markerColor: 4,
    userId: localStorage.getItem("id")
  })
  const [isView, setIsView] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [emails, setEmails] = useState<any>([])
  const [emailTemp, setEmailTemp] = useState("")
  const [chat, setChat] = useState("")

  useEffect(() => {
    if (noteShapeModal.data) {
      dispatch(getNoteChat(noteShapeModal?.data?.id))
      dispatch(getNoteDeleteRequests(noteShapeModal?.data?.id))
      setIsView(true)
      setForm({
        ...form,
        name: noteShapeModal.data.name,
        description: noteShapeModal.data.description,
        markerColor: noteShapeModal.data.markerColor
      })
      setEmails(
        noteShapeModal.data.recipientEmails
      )
    }
    else {
      dispatch(clearChatList())
      setEmails([])
    }
  }, [noteShapeModal])

  const handleChangeForm = (e: any) => {
    let name = e.target.name
    let value = e.target.value
    setForm({
      ...form,
      [name]: value
    })
  }

  const handleCancel = () => {
    dispatch(setNoteShapeModal({ status: false }))
  }

  const handleSave = (e: any) => {
    if (isEdit) {
      let data = {
        id: noteShapeModal?.data?.id,
        description: form?.description,
        name: form?.name,
        markerColor: form?.markerColor,
        recipientEmails: emails
      }
      console.log(data)
      dispatch<any>(editNoteMarker(data))
        .unwrap()
        .then((res: any) => {
          if (res.status >= 400) {
            Swal.fire("Edit path note failed!", res?.data?.message);
          }
          else {
            handleCancel()
            dispatch(setNoteShape([]))
            dispatch<any>(getNoteListByJobNumberId(jobNumberIdActive.id))
              .unwrap()
              .then((res: any) => {
                let noteListNew: any = noteList?.filter((item: any) => item.jobNumberId !== jobNumberIdActive.id)
                dispatch(setNoteList(noteListNew.concat(res.data)))
              })
          }
        })
    }
    else {
      dispatch<any>(postNoteMarker({
        ...form,
        recipientEmails: emails,
      }))
        .unwrap()
        .then((res: any) => {
          if (res.status >= 400) {
            Swal.fire("Add shape note failed!", res?.data?.message);
          }
          else {
            if (chat) {
              dispatch(createComment({
                markerId: res?.data?.id,
                comment: chat,
                userId: localStorage.getItem('id')
              }))
            }
            handleCancel()
            dispatch(setNoteShape([]))
            dispatch<any>(getNoteListByJobNumberId(jobNumberIdActive.id))
              .unwrap()
              .then((res: any) => {
                let noteListNew: any = noteList?.filter((item: any) => item.jobNumberId !== jobNumberIdActive.id)
                dispatch(setNoteList(noteListNew.concat(res.data)))
              })
          }
        })
    }
  }

  const handleEdit = () => {
    setIsView(false)
    setIsEdit(true)
  }

  const handleDelete = () => {
    dispatch<any>(deleteTempNoteMarker(noteShapeModal?.data?.id))
      .unwrap()
      .then((res: any) => {
        dispatch<any>(getNoteListByJobNumberId(noteShapeModal?.data?.jobNumberId))
          .unwrap()
          .then((res: any) => {
            let noteListNew: any = noteList?.filter((item: any) => item.jobNumberId !== noteShapeModal?.data?.jobNumberId)
            dispatch(setNoteList(noteListNew.concat(res.data)))
            dispatch(setNoteShapeModal({ status: false }))
          })
        dispatch<any>(getNoteListDeleted(noteShapeModal?.data?.jobNumberId))
          .unwrap()
          .then((res: any) => {
            let noteListDeletedNew: any = noteListDeleted?.filter((item: any) => item.jobNumberId !== noteShapeModal?.data?.jobNumberId)
            dispatch(setNoteListDeleted(noteListDeletedNew.concat(res.data)))
          })
      })
  }

  const handleRequestDelete = () => {
    dispatch<any>(requestDeleteNoteMarker(noteShapeModal?.data?.id))
      .unwrap()
      .then((res: any) => {
        Swal.fire("Success", `Your delete action has been requested to ${noteShapeModal?.data?.creator}`)
      })
  }

  const handleRejectRequestDelete = (id: string) => {
    dispatch<any>(rejectRequestDeleteNoteMarker(id))
      .unwrap()
      .then((res: any) => {
        dispatch(getNoteDeleteRequests(noteShapeModal?.data?.id))
      })
  }

  const handleSubmitChat = () => {
    dispatch<any>(createComment({
      markerId: noteShapeModal?.data?.id,
      comment: chat,
      userId: localStorage.getItem('id')
    }))
      .unwrap()
      .then(() => {
        setChat("")
        dispatch(getNoteChat(noteShapeModal?.data?.id))
      })
  }

  const handleComplete = (id: string) => {
    dispatch<any>(completeMarker({ targetMarkerId: id, userId: localStorage.getItem('id') }))
      .unwrap()
      .then(() => {
        dispatch<any>(getNoteListByJobNumberId(jobNumberIdActive.id))
          .unwrap()
          .then((res: any) => {
            dispatch(setNoteList(res.data))
            dispatch(setNoteShapeModal({ status: false }))
            Swal.fire("Success", "Notes successfully completed", "success")
          })
      })
  }

  return (
    <div className="formnote">
      <h3>Shape<X onClick={handleCancel} /></h3>
      <div className="creator">
        {isView && (
          <span>
            created by {noteShapeModal?.data?.creator} at {moment(new Date(noteShapeModal?.data?.createdDate)).format("MM-DD-yyyy hh:mm:ss")}
          </span>
        )}
      </div>
      <form>
        <TextField
          className="inp"
          variant="outlined"
          type="text"
          label="Subject"
          size="small"
          name="name"
          value={form.name}
          onChange={handleChangeForm}
          inputProps={{
            readOnly: isView
          }}
        />
        <TextField
          className="inp"
          variant="outlined"
          type="text"
          label="Note"
          size="small"
          multiline={true}
          name="description"
          value={form.description}
          onChange={handleChangeForm}
          inputProps={{
            readOnly: isView
          }}
        />
        <TextField
          id="select"
          className="inp"
          label="Color"
          variant="outlined"
          size="small"
          select
          name="markerColor"
          value={form.markerColor}
          onChange={handleChangeForm}
          inputProps={{
            readOnly: isView
          }}>
          {noteEnums?.markerColors?.map((item: any, itemIndex: number) => (
            <MenuItem key={item} value={item.value}>{item.display}</MenuItem>
          ))}
        </TextField>
        <Autocomplete
          multiple
          options={[...emails, emailTemp]}
          id="disable-clearable"
          value={emails}
          onInputChange={(e: any) => setEmailTemp(e.target?.value || "")}
          onChange={(e, value) => setEmails(value)}
          className="inp"
          disableClearable
          disabled={isView}
          renderInput={(params) => <TextField {...params} label="To" size="small" placeholder="Search email" variant="outlined" />}
        />
        <br />
        <Card>
          <CardContent>
            <Typography variant="h6">
              Chats
            </Typography>
            <List>
              {chatList.map((chat: any) => (
                <ListItem>
                  <ListItemText
                    primary={chat.comment}
                    secondary={`> ${chat.userName} at ${chat.time}`}

                  />
                </ListItem>
              ))}
            </List>
          </CardContent>
          <CardActions>
            <TextField fullWidth variant="outlined" label="Message" value={chat} onChange={(e) => setChat(e.target.value)} />
            {(emails.includes(localStorage.getItem("email")) || localStorage.getItem("email") === noteShapeModal?.data?.creator) && (
              <IconButton onClick={handleSubmitChat}>
                <Send />
              </IconButton>
            )}
          </CardActions>
        </Card>
        {localStorage.getItem("email") === noteShapeModal?.data?.creator && (
          <>
            <br />
            <Card>
              <CardContent>
                <Typography variant="h6">
                  Delete Request
                </Typography>
                <List>
                  {requestDeleteList.map((request: any) => (
                    <ListItem>
                      <ListItemText
                        primary={request.requestedBy}
                        secondary={`> at ${request.dateRequest}`}
                      />
                      <ListItemSecondaryAction>
                        <Tooltip title="reject request">
                          <IconButton onClick={() => handleRejectRequestDelete(request.id)}>
                            <XCircle />
                          </IconButton>
                        </Tooltip>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </>
        )}
        {(localStorage.getItem("email") === noteShapeModal?.data?.creator || !isView)
          ? (
            <>
              <br />
              <div className="wrapbutton" >
                <div className="left">
                  {noteShapeModal?.data?.status === 0 && (
                    <Button className="done" onClick={() => handleComplete(noteShapeModal?.data?.id)}>
                      Complete Note
                    </Button>
                  )}
                </div>
                {isView
                  ? (
                    <>
                      <Button className="delete" variant="outlined" onClick={handleDelete}>
                        <Trash /> Delete
                      </Button>
                      <Button className="edit" variant="outlined" onClick={handleEdit}>
                        <Edit2 /> Edit
                      </Button>
                    </>
                  )
                  : (
                    <Button className="save" variant="outlined" onClick={handleSave}>
                      <Save /> Save
                    </Button>
                  )
                }
              </div>
            </>
          )
          : (
            <>
              <br />
              <div className="wrapbutton" >
                <Button className="delete" variant="outlined" onClick={handleRequestDelete}>
                  <Trash /> Delete
                </Button>
              </div>
            </>
          )
        }
      </form>
    </div>
  );
}
